export enum EArb {
  NO = 'No, ARB not required',
  YES_PENDING = 'Yes, ARB started/pending',
  YES_DONE = 'Yes, ARB complete'
}
